<div *ngIf="ecResource && ec" class="ec-dashboard-container p-20" fxLayout="column">
    <div fxLayout="row" fxLayoutGap="16px">
        <div fxFlex="60" fxLayout="column" class="ec-dashboard-panel-1">
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <div>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <app-icon [name]="ecResource|entityIcon" class="mr-12 community-icon"></app-icon>
                        <div class="txt-h-18-7">{{ecResource.name}}</div>
                    </div>
                    <div class="mt-12 txt-s-14-4">
                        {{ecResource|entityType|i18n}}
                    </div>
                </div>
                <button *ngIf="!isAdvUser" app-small-ghost-button class="app-button-alert"
                        [disabled]="busy || !communityDeletable"
                        (click)="onClickDeleteCommunity()">
                    <app-icon name="fal-trash-alt"></app-icon>
                    {{'Delete community'|i18n}}
                </button>
            </div>
            <div fxLayout="row" fxLayoutGap="32px" class="mt-16">
                <div fxLayout="column" fxFlexFill
                     class="ec-dashboard-panel-2 pt-10 pl-16 pr-16 pb-28">
                    <div fxLayout="row" fxLayoutAlign="space-between">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <app-icon class="mr-12 txt-h-14-4" name="fal-list-alt"></app-icon>
                            <div class="txt-h-16-7">{{'Details'|i18n}}</div>
                        </div>
                        <div fxLayout="row" *ngIf="!isAdvUser">
                            <button app-small-ghost-button class="app-base-button"
                                    [disabled]="!communityUpdatable"
                                    (click)="onClickEditCommunity()">
                                <app-icon name="fal-cog"></app-icon>
                                {{'Configuration'|i18n}}
                            </button>
                        </div>
                    </div>
                    <div fxLayout="column" class="mt-16" fxLayoutGap="16px">
                        <div *ngIf="permOnReps || isAdvUser" fxLayout="row">
                            <div fxFlex="50" fxLayoutAlign="start center" class="txt-p-14-7">
                                {{('Representative name'|i18n) + ':'}}
                            </div>
                            <div fxFlex="50" fxLayout="row" fxLayoutAlign="space-between center">
                                <div class="txt-p-14-4">
                                    {{representative ? representativeToString(representative) : 'No representative assigned'|i18n}}
                                </div>
                                <button *ngIf="!isAdvUser" app-ghost-button fxLayoutAlign="space-around center"
                                        fxLayoutGap="16px"
                                        [disabled]="!representativeUpdatable"
                                        (click)="openUpdateRefDialog()">
                                    <app-icon name="fal-pencil-alt" class="mr-0"></app-icon>
                                </button>
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxFlex="50" class="txt-p-14-7">
                                {{('Activation date'|i18n) + ':'}}
                            </div>
                            <div fxFlex="50" class="txt-p-14-4" *ngIf="isDefined(ec.activation_date)">
                                {{ec.activation_date|i18nDate}}
                            </div>
                            <div fxFlex="50" class="txt-p-14-4" *ngIf="!isDefined(ec.activation_date)">
                                <app-icon icon-color-w name="fas-exclamation-triangle"></app-icon>
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxFlex="50" class="txt-p-14-7">
                                {{('Office address'|i18n) + ':'}}
                            </div>
                            <div fxFlex="50" class="txt-p-14-4">
                                {{addressToString(ec.address)}}
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxFlex="50" class="txt-p-14-7">
                                {{('Energy market zone'|i18n) + ':'}}
                            </div>
                            <div fxFlex="50" class="txt-p-14-4">
                                {{ec.zone}}
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxFlex="50" class="txt-p-14-7">
                                {{('Mode'|i18n) + ':'}}
                            </div>
                            <div fxFlex="50" class="txt-p-14-4">
                                <ng-container *ngIf="ecMode">
                                    <span class="mr-10">{{ecMode|ecMode|i18n}}</span>
                                    <ng-container [ngSwitch]="ecMode">
                                        <app-icon *ngSwitchCase="ECMode.BASE" name="fas-info-circle"
                                                  [title]="'All community energy measures are based on statistical profiles'|i18n">
                                        </app-icon>
                                        <app-icon *ngSwitchCase="ECMode.ADVANCED" name="fas-info-circle"
                                                  [title]="'All PODs in the community are monitored by smart meters'|i18n">
                                        </app-icon>
                                        <app-icon *ngSwitchCase="ECMode.HYBRID" name="fas-info-circle"
                                                  [title]="'Energy data for some PODs are derived from smart meter monitoring, while others are based on statistical profiles'|i18n">
                                        </app-icon>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="!ecMode">
                                    <span class="mr-10">{{"Undefined__{f}"|i18n}}</span>
                                    <app-icon name="fas-info-circle"
                                              [title]="'In the absence of resources, the nature of energy data cannot be defined.'|i18n">
                                    </app-icon>
                                </ng-container>
                            </div>
                        </div>
                        <div *ngIf="showContractualMode" fxLayout="row">
                            <div fxFlex="50" class="txt-p-14-7">
                                {{('Contractual mode'|i18n) + ':'}}
                            </div>
                            <div fxFlex="50" class="txt-p-14-4">
                                {{contractualMode.contract_name|i18n}}
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxFlex="50" class="txt-p-14-7">
                                {{('Creation date'|i18n) + ':'}}
                            </div>
                            <div fxFlex="50" class="txt-p-14-4">
                                {{isDefined(ec.created_on) ? (ec.created_on|i18nDate) : ('No date assigned'|i18n)}}
                            </div>
                        </div>
                        <div fxLayout="row">
                            <div fxFlex="50" class="txt-p-14-7">
                                {{('Last modified date'|i18n) + ':'}}
                            </div>
                            <div fxFlex="50" class="txt-p-14-4">
                                {{isDefined(ec.modified_on) ? (ec.modified_on|i18nDate) : ('No date assigned'|i18n)}}
                            </div>
                        </div>
                    </div>
                    <div *ngIf="hasWeatherForecast" fxLayout="row" fxLayoutAlign="end" class="mt-32">
                        <button app-small-ghost-button
                                (click)="onClickWeatherForecast()">
                            <app-icon name="fal-globe-europe"></app-icon>
                            {{'Weather forecast'|i18n}}
                        </button>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="mt-12" *ngIf="!isAdvUser">
                        <button app-small-ghost-button class="app-base-button"
                                (click)="onClickDocuments()">
                            <app-icon name="fal-file"></app-icon>
                            {{'Documents'|i18n}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="ec-dashboard-panel-3 mt-16">
                <app-ec-measure-aggregations
                                             [refreshFrequency]="AGGREGATION_REFRESH_FREQUENCY"
                                             [aggregations]="ecAggregations">
                </app-ec-measure-aggregations>
            </div>
        </div>
        <div fxFlex="40" fxLayout="column">
            <div fxLayout="row">
                <div fxFlex="100" fxLayout="column" class="ec-dashboard-panel-1">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <app-icon class="mr-12 txt-h-14-4" name="fal-map-marker-alt"></app-icon>
                        <div class="txt-h-14-7">{{'Localization'|i18n}}</div>
                    </div>
                    <div class="mt-32">
                        <div *ngIf="!ec.spatial_coordinates">{{'No coordinates set'|i18n}}</div>
                        <app-google-maps *ngIf="!!ec.spatial_coordinates"
                                         [coordinates]="ec.spatial_coordinates"
                                         [ecPodCoordinates]="ecPodCoordinates"
                                         [showMarker]="true">
                        </app-google-maps>
                    </div>
                </div>
            </div>
            <div fxLayout="row" class="mt-12">
                <div fxLayout="column" fxLayoutGap="24px" fxFlex="50">
                    <div fxLayout="column" class="ec-dashboard-panel-1 mr-12">
                        <!-- CURRENT ACTIVE MEMBERS -->
                        <div fxLayout="column" fxFlex="100">
                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="20">
                                <div fxFlex="80">
                                    <app-icon class="mr-12 txt-s-16-4" name="fal-user-check"></app-icon>
                                    <span class="txt-h-16-7">{{'Subjects'|i18n}}</span>
                                </div>
                                <div fxFlex="20" fxLayoutAlign="flex-end" class="txt-h-26-7"
                                     *ngIf="ecMembersStatistics; else loadingStatistics">
                                    {{ecMembersStatistics.counts?.PF.active + ecMembersStatistics.counts?.PF.inactive
                                + ecMembersStatistics.counts?.PG.active + ecMembersStatistics.counts?.PG.inactive}}
                                </div>
                            </div>
                            <div fxLayout="column" class="mt-8" *ngIf="ecMembersStatistics">
                                <div fxLayout="row" fxLayoutAlign="center">
                                    <div fxFlex="60" class="txt-h-14-4" fxLayoutAlign="start center"></div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{'Active__a'|i18n}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{'Inactive__a'|i18n}}</div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="center">
                                    <div fxFlex="60" class="txt-h-14-4" fxLayoutAlign="start center">{{'Individuals'|i18n}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{ecMembersStatistics.counts?.PF.active}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{ecMembersStatistics.counts?.PF.inactive}}</div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="center">
                                    <div fxFlex="60" class="txt-h-14-4" fxLayoutAlign="start center">{{'Corporate entities'|i18n}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{ecMembersStatistics.counts?.PG.active}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{ecMembersStatistics.counts?.PG.inactive}}</div>
                                </div>
                                <div class="mt-2"></div>
                                <mat-divider></mat-divider>
                                <div fxLayout="row" fxLayoutAlign="center" class="mt-4">
                                    <div fxFlex="60" class="txt-h-14-4" fxLayoutAlign="start center">{{'Totals'|i18n}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">
                                        {{ecMembersStatistics.counts?.PG.active + ecMembersStatistics.counts?.PF.active}}
                                    </div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">
                                        {{ecMembersStatistics.counts?.PG.inactive + ecMembersStatistics.counts?.PF.inactive}}
                                    </div>
                                </div>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="flex-end center" fxFlex="50" class="mt-18"
                                 *ngIf="!isAdvUser">
                                <button app-small-ghost-button
                                        (click)="onClickMembers()">
                                    {{'Subjects'|i18n}}
                                    <app-icon class="app-icon-right" name="fal-arrow-right"></app-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div fxLayout="column" class="ec-dashboard-panel-1 mr-12">
                        <!-- MONITORED PODs -->
                        <div fxFlex="100" fxLayout="column">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="row" fxFlex="100">
                                    <app-icon class="mr-12 txt-s-16-7 " name="fal-users"></app-icon>
                                    <span class="txt-h-16-7">{{'PODs'|i18n}}</span>
                                </div>
                                <div class="txt-h-24-7" *ngIf="ecPodsStatistics; else loadingStatistics">
                                    {{ecPodsStatistics.total_pods_count}}
                                </div>
                            </div>
                            <div *ngIf="ecPodsStatistics" fxLayout="column" class="mt-8">
                                <div fxLayout="row" fxLayoutAlign="center">
                                    <div fxFlex="60" class="txt-h-14-4" fxLayoutAlign="start center"></div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{'Active__a'|i18n}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{'Inactive__a'|i18n}}</div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="center">
                                    <div fxFlex="60" class="txt-h-14-4" fxLayoutAlign="start center">{{'Monitored__a'|i18n}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{ecPodsStatistics.monitored_active_count}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{ecPodsStatistics.monitored_inactive_count}}</div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="center">
                                    <div fxFlex="60" class="txt-h-14-4" fxLayoutAlign="start center">{{'Statistical__a'|i18n}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{ecPodsStatistics.statistical_active_count}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{ecPodsStatistics.statistical_inactive_count}}</div>
                                </div>
                                <div class="mt-2"></div>
                                <mat-divider></mat-divider>
                                <div fxLayout="row" fxLayoutAlign="center" class="mt-4">
                                    <div fxFlex="60" class="txt-h-14-4" fxLayoutAlign="start center">{{'Totals'|i18n}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{ecPodsStatistics.monitored_active_count +
                                    ecPodsStatistics.statistical_active_count}}</div>
                                    <div fxFlex="20" class="txt-h-14-7" fxLayoutAlign="center center">{{ecPodsStatistics.monitored_inactive_count +
                                    ecPodsStatistics.statistical_inactive_count}}</div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="inactivePodsCount > 0" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px"
                             economics-warning class="mt-30">
                            <app-icon icon-color-w name="fas-info-circle"></app-icon>
                            <div *ngIf="inactivePodsCount === 1">{{ 'There is {0} POD with no activation date. Fill in the date to count the POD in Economics.'|i18n:inactivePodsCount }}</div>
                            <div *ngIf="inactivePodsCount > 1">{{ 'There are {0} POD with no activation date. Fill in the date to count the POD in Economics.'|i18n:inactivePodsCount }}</div>
                        </div>
                        <div *ngIf="missingProfileCount > 0" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px"
                             economics-warning class="mt-30">
                            <app-icon icon-color-w name="fas-info-circle"></app-icon>
                            <div *ngIf="missingProfileCount === 1">{{ 'There is 1 POD without a defined statistical profile. Fill in the profile to obtain estimates of measures and economic data. Send a registration invitation to interested parties, or fill in statistical profiles manually.'|i18n }}</div>
                            <div *ngIf="missingProfileCount > 1">{{ 'There are {0} PODs without a defined statistical profile. Fill in the profile to obtain estimates of measures and economic data. Send a registration invitation to interested parties, or fill in statistical profiles manually.'|i18n:(ecPodsStatistics.undefined_active_count+ecPodsStatistics.undefined_inactive_count) }}</div>
                        </div>
                    </div>

                </div>

                <!-- PLANTS -->
                <div fxLayout="column" class="ec-dashboard-panel-1" fxFlex="50">
                    <div fxLayout="column" fxFlex="100">
                        <!-- PLANTS -->
                        <!-- Active plants -->
                        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="20">
                            <div fxFlex="80">
                                <app-icon class="mr-12 txt-s-16-4 " name="fal-solar-panel"></app-icon>
                                <span class="txt-h-16-7">{{'Working plants'|i18n}}</span>
                            </div>
                            <div fxFlex="20" fxLayoutAlign="flex-end" *ngIf="ecPlantsStatistics; else loadingStatistics">
                                    <span class="txt-h-26-7">
                                        {{ecPlantsStatistics.producer_active_count +
                                    ecPlantsStatistics.prosumer_active_count +
                                    ecPlantsStatistics.third_party_producer_active_count}}
                                    </span>
                            </div>
                        </div>
                        <div fxLayout="column" *ngIf="ecPlantsStatistics">
                            <div fxLayout="row" fxFlex="100" class="mt-12">
                                <div fxFlex="60" class="txt-h-14-4"></div>
                                <div fxFlex="40" class="txt-h-14-4 t-center">
                                    {{'Total power'|i18n}}
                                </div>
                            </div>
                            <div fxLayout="row">
                                <div fxFlex="40" class="txt-h-14-4">
                                    {{('Prosumer'|i18n)}}
                                </div>
                                <div fxFlex="20" class="txt-h-14-7 t-center">
                                    {{ecPlantsStatistics.prosumer_active_count}}
                                </div>
                                <div fxFlex="40" class="txt-h-14-4 t-center">
                                    <span *ngIf="!!ecPlantsStatistics.prosumer_active_count">{{ecPlantsStatistics.prosumer_active_total_power|niceValue:'kW'}}</span>
                                    <span *ngIf="!!!ecPlantsStatistics.prosumer_active_count">{{'-'}}</span>
                                </div>
                            </div>
                            <div fxLayout="row">
                                <div fxFlex="40" class="txt-h-14-4">
                                    {{('Producers'|i18n)}}
                                </div>
                                <div fxFlex="20" class="txt-h-14-7 t-center">
                                    {{ecPlantsStatistics.producer_active_count}}
                                </div>
                                <div fxFlex="40" class="txt-h-14-4 t-center">
                                    <span *ngIf="!!ecPlantsStatistics.producer_active_count">{{ecPlantsStatistics.producer_active_total_power|niceValue:'kW'}}</span>
                                    <span *ngIf="!!!ecPlantsStatistics.producer_active_count">{{'-'}}</span>
                                </div>
                            </div>
                            <div fxLayout="row">
                                <div fxFlex="40" class="txt-h-14-4">
                                    {{('Third party producers'|i18n)}}
                                </div>
                                <div fxFlex="20" class="txt-h-14-7 t-center">
                                    {{ecPlantsStatistics.third_party_producer_active_count}}
                                </div>
                                <div fxFlex="40" class="txt-h-14-4 t-center">
                                    <span *ngIf="!!ecPlantsStatistics.third_party_producer_active_count">{{ecPlantsStatistics.third_party_producer_active_total_power|niceValue:'kW'}}</span>
                                    <span *ngIf="!!!ecPlantsStatistics.third_party_producer_active_count">{{'-'}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- PLANTS -->
                        <!-- Inactive plants -->
                        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="20" class="mt-24">
                            <div fxFlex="80">
                                <app-icon class="mr-12 txt-s-16-4 " name="fal-solar-panel"></app-icon>
                                <span class="txt-h-16-7">{{'Pending plants'|i18n}}</span>
                                <app-icon *ngIf="inactivePlantsCount > 0" icon-color-w name="fas-exclamation-triangle"
                                          class="ml-10"
                                          [title]="'There are plants waiting to be activated. These will be counted in Economics according to their activation date.'|i18n">
                                </app-icon>
                            </div>
                            <div fxFlex="20" fxLayoutAlign="flex-end" *ngIf="ecPlantsStatistics; else loadingStatistics">
                                    <span class="txt-h-26-7">
                                        {{ecPlantsStatistics?.producer_inactive_count +
                                    ecPlantsStatistics?.prosumer_inactive_count +
                                    ecPlantsStatistics?.third_party_producer_inactive_count}}
                                    </span>
                            </div>
                        </div>
                        <div fxLayout="column" *ngIf="ecPlantsStatistics">
                            <div fxLayout="row" fxFlex="100" class="mt-12">
                                <div fxFlex="60" class="txt-h-14-4"></div>
                                <div fxFlex="40" class="txt-h-14-4 t-center">
                                    {{'Total power'|i18n}}
                                </div>
                            </div>
                            <div fxLayout="row">
                                <div fxFlex="40" class="txt-h-14-4">
                                    {{('Prosumer'|i18n)}}
                                </div>
                                <div fxFlex="20" class="txt-h-14-7 t-center">
                                    {{ecPlantsStatistics.prosumer_inactive_count}}
                                </div>
                                <div fxFlex="40" class="txt-h-14-4 t-center">
                                    <span *ngIf="!!ecPlantsStatistics.prosumer_inactive_count">{{ecPlantsStatistics.prosumer_inactive_total_power|niceValue:'kW'}}</span>
                                    <span *ngIf="!!!ecPlantsStatistics.prosumer_inactive_count">{{'-'}}</span>
                                </div>
                            </div>
                            <div fxLayout="row">
                                <div fxFlex="40" class="txt-h-14-4">
                                    {{('Producers'|i18n)}}
                                </div>
                                <div fxFlex="20" class="txt-h-14-7 t-center">
                                    {{ecPlantsStatistics.producer_inactive_count}}
                                </div>
                                <div fxFlex="40" class="txt-h-14-4 t-center">
                                    <span *ngIf="!!ecPlantsStatistics.producer_inactive_count">{{ecPlantsStatistics.producer_inactive_total_power|niceValue:'kW'}}</span>
                                    <span *ngIf="!!!ecPlantsStatistics.producer_inactive_count">{{'-'}}</span>
                                </div>
                            </div>
                            <div fxLayout="row">
                                <div fxFlex="40" class="txt-h-14-4">
                                    {{('Third party producers'|i18n)}}
                                </div>
                                <div fxFlex="20" class="txt-h-14-7 t-center">
                                    {{ecPlantsStatistics.third_party_producer_inactive_count}}
                                </div>
                                <div fxFlex="40" class="txt-h-14-4 t-center">
                                    <span *ngIf="!!ecPlantsStatistics.third_party_producer_inactive_count">{{ecPlantsStatistics.third_party_producer_inactive_total_power|niceValue:'kW'}}</span>
                                    <span *ngIf="!!!ecPlantsStatistics.third_party_producer_inactive_count">{{'-'}}</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="inactivePlantsCount > 0" fxLayout="row" fxLayoutAlign="center center"
                             fxLayoutGap="30px" economics-warning class="mt-30">
                            <app-icon icon-color-w name="fas-info-circle"></app-icon>
                            <div *ngIf="inactivePlantsCount === 1">{{ 'There is {0} plant with no activation date. Fill in the date to count the plant in Economics.'|i18n:inactivePlantsCount }}</div>
                            <div *ngIf="inactivePlantsCount > 1">{{ 'There are {0} plants with no activation date. Fill in the date to count the plants in Economics.'|i18n:inactivePlantsCount }}</div>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="flex-end center" fxFlex="50" class="mt-30">
                            <button app-small-ghost-button
                                    (click)="onClickResources()">
                                {{'Resources'|i18n}}
                                <app-icon class="app-icon-right" name="fal-arrow-right"></app-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #configCoordinates let-data>
    <h1 mat-dialog-title>{{'Position of {0}'|i18n:(ecResource.path|nicePath)}}</h1>
    <div mat-dialog-content fxLayout="column" fxLayoutGap="0.5rem" class="map-dialog">
        <app-google-maps [coordinates]="data.coords"
                         [showMarker]="data.coordsPresent"
                         [chooseAddress]="true"
                         (coordinatesChange)="data.onCoordsChange($event)">
        </app-google-maps>
        <button *ngIf="data.coordsPresent" mat-stroked-button color="primary"
                [title]="'Remove current coordinates'|i18n"
                (click)="data.onRemoveCoords()">
            {{'Clear'|i18n}}
        </button>
        <div *ngIf="!data.coordsPresent">
            <span class="no-coords">{{'No coordinates set'|i18n}}</span>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="primary"
                [disabled]="!data.dirty"
                [mat-dialog-close]="data">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Ok'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteCommunity let-close="close">
    <div class="ml-42 mr-42 t-center">
        {{('Are you sure you want to delete'|i18n)}}<strong>{{' ' + ecResource.name}}</strong>{{'?'}}<br>
        {{'In this way the community, its subjects, and its resources will be erased.'|i18n}}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{'No, cancel'|i18n}}
        </button>
        <button app-primary-button (click)="close(true)">
            {{'Yes, confirm'|i18n}}
        </button>
    </div>
</ng-template>


<ng-template #editCommunity let-data let-close="close">
    <div class="edit-community app-dialog-background">
        <div fxLayout="column" fxLayoutGap="0.5rem" class="map-dialog">
            <app-ec-editor [community]="data.community"
                           [hierarchyEntity]="data.hierarchyEntity"
                           (saved)=" saveCommunity($event,close)">
            </app-ec-editor>
        </div>
    </div>
</ng-template>

<ng-template #assignRepresentative let-data>
    <div class="assign-container">
        <div fxLayoutAlign="end">
            <button mat-icon-button [mat-dialog-close]="false">
                <app-icon name="fal-times"></app-icon>
            </button>
        </div>
        <div class="data-assign-container">
            <div class="main-title mt-32">
                {{'Update representative assigned to {0}'|i18n:ecResource.name}}
            </div>
            <div fxLayout="column" class="form mt-32">
                <div>{{'Select the representative to whom assign the community'|i18n}}.</div>
                <div class="select-container" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
                    <div fxFlex="30">{{'Select representative'|i18n}}:</div>
                    <div fxFlex="60" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
                        <div fxFlex app-input-container class="device-search-container">
                            <input app-input #representativeSearch class="device-search"
                                   [formControl]="representativeFormControl"
                                   [matAutocomplete]="representativeAutocomplete" [spellcheck]="false"
                                   [placeholder]="'Select representative'|i18n"
                                   (focusout)="onRepresentativeLoseFocus($event)">
                            <app-icon *ngIf="!!representativeFormControl.value" name="fal-times"
                                      class="right-symbol clear"
                                      (click)="onClickResetRepresentativeSearch()">
                            </app-icon>
                            <mat-autocomplete #representativeAutocomplete="matAutocomplete"
                                              [displayWith]="representativeDisplayFn">
                                <mat-option *ngFor="let rep of filteredRepresentatives |async" [value]="rep">
                                    {{rep.personal_data.first_name + ' ' + rep.personal_data.last_name}}
                                </mat-option>
                            </mat-autocomplete>
                            <svg *ngIf="!representativeFormControl.value" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 512 512"
                                 class="right-symbol mag-glass">
                                <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                            </svg>
                        </div>
                        <button app-primary-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                                [mat-dialog-close]="representativeFormControl.value"
                                [disabled]="!representativeFormControl.value">
                            <span>{{'Confirm'|i18n}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="representative" fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="32px"
                 class="mt-48">
                <span>{{'or'|i18n}}</span>
                <button app-ghost-button class="app-button-alert" fxLayoutAlign="space-around center" fxLayoutGap="16px"
                        (click)="openAssignationRemovalDialog()">
                    <app-icon name="fal-trash-alt"></app-icon>
                    <span>{{'Remove assignation'|i18n}}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #confirmAssignationRemoval let-data>
    <div class="remove-container">
        <div fxLayoutAlign="end">
            <button mat-icon-button [mat-dialog-close]="false">
                <app-icon name="fal-times"></app-icon>
            </button>
        </div>
        <div class="remove-data-container" fxLayout="column" fxLayoutGap="64px">
            <div class="main-title mt-32" fxLayoutAlign="center center">
                {{'Remove association'|i18n}}
            </div>
            <div fxLayout="column" fxLayoutAlign="center center">
                <span>{{'Are you sure you want to remove the association between representative {0} and {1}?'|i18n:getNameFrom(this.representative.personal_data):ecResource.name}}</span>
                <span>{{'The community will remain without an assigned representative'|i18n}}.</span>
                <span>{{'The representative will still remain visible as a user in the representative table'|i18n}}.</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="24px">
                <button app-ghost-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                        [mat-dialog-close]="false">
                    <span>{{'No, cancel'|i18n}}</span>
                </button>
                <button app-primary-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                        [mat-dialog-close]="true">
                    <span>{{'Yes, proceed'|i18n}}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #loadingStatistics>
    <div fxLayout="row" fxLayoutAlign="center center">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
    </div>
</ng-template>
